import { MNElementContent } from '../elements/elementModelTypes';
import { TiptapContent, TiptapContentNode, TiptapNodeType } from '../tiptap/tiptapTypes';
import { getTaskListLabelIds } from './taskListLabelUtils';
import { TaskListContentVersion } from './taskListContentVersionUtils';

/**
 * Creates the minimal editable Tiptap document for a blank single-editor task list.
 */
export const createInitialSingleEditorTaskListDocument = (): TiptapContent => ({
    type: TiptapNodeType.doc,
    content: [
        {
            type: TiptapNodeType.taskList,
            content: [
                {
                    type: TiptapNodeType.taskItem,
                    attrs: { checked: false },
                    content: [
                        {
                            type: TiptapNodeType.paragraph,
                        },
                    ],
                },
            ],
        },
    ],
});

/**
 * Creates the persisted content payload for a new single-editor task list element.
 */
export const createInitialSingleEditorTaskListContent = (): MNElementContent => ({
    version: TaskListContentVersion.SingleEditor,
    textContent: createInitialSingleEditorTaskListDocument(),
});

/**
 * Creates a single-editor task list document containing the given task item nodes.
 * No title node, so the list renders without a title.
 */
export const createSingleEditorTaskListDocumentWithItems = (taskItems: TiptapContentNode[]): TiptapContent => ({
    type: TiptapNodeType.doc,
    content: [
        {
            type: TiptapNodeType.taskList,
            content: taskItems,
        },
    ],
});

/**
 * Creates the content payload for a task list element seeded with existing task item nodes
 * (e.g. one dragged out of another single-editor task list).
 */
export const createSingleEditorTaskListContentWithItems = (taskItems: TiptapContentNode[]): MNElementContent => {
    const textContent = createSingleEditorTaskListDocumentWithItems(taskItems);

    return {
        version: TaskListContentVersion.SingleEditor,
        textContent,
        labels: getTaskListLabelIds(textContent),
    };
};
